'use client'

import { useEffect } from 'react'

export const ChunkReload = () => {
  useEffect(() => {
    const handler = (event: Event) => {
      // @ts-ignore
      if (event?.message?.includes('Loading chunk') || event?.message?.includes('chunk')) {
        window.location.reload()
      }
    }
    window.addEventListener('error', handler)
    return () => window.removeEventListener('error', handler)
  }, [])

  return null
}